let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ksuHZ")).then(() => parcelRequire('i6eF3'));